import type { WidgetMeta, WidgetConfig, RolePreset, WidgetId } from "types/dashboard";

// --- Widget catalog ---

export const WIDGET_CATALOG: WidgetMeta[] = [
  {
    id: "stat_cards",
    label: "Statistiques rapides",
    description: "Compteurs d'ordres par statut et véhicules",
    defaultSize: "large",
    icon: "chart",
    category: "stats",
  },
  {
    id: "rdv_du_jour",
    label: "Rendez-vous du jour",
    description: "Prochains rendez-vous planifiés aujourd'hui",
    defaultSize: "medium",
    icon: "calendar",
    category: "planning",
  },
  {
    id: "recent_ordres",
    label: "Ordres récents",
    description: "Les 5 derniers ordres créés",
    defaultSize: "medium",
    icon: "document",
    category: "ordres",
  },
  {
    id: "ordres_bloques",
    label: "Ordres signalés",
    description: "Ordres avec le drapeau bloqué",
    defaultSize: "medium",
    icon: "warning",
    category: "ordres",
  },
  {
    id: "ordres_urgents",
    label: "Ordres urgents",
    description: "Ordres avec le drapeau urgent",
    defaultSize: "medium",
    icon: "flag",
    category: "ordres",
  },
  {
    id: "ordres_by_status",
    label: "Répartition par statut",
    description: "Nombre d'ordres par statut (graphique)",
    defaultSize: "medium",
    icon: "chart",
    category: "ordres",
  },
  {
    id: "devis_en_attente",
    label: "Devis en attente",
    description: "Ordres avec devis envoyés mais pas encore signés",
    defaultSize: "medium",
    icon: "document",
    category: "finances",
  },
  {
    id: "paiements_en_attente",
    label: "Paiements en attente",
    description: "Acomptes et soldes demandés mais pas encore payés",
    defaultSize: "medium",
    icon: "payment",
    category: "finances",
  },
  {
    id: "payments_chart",
    label: "Historique des paiements",
    description: "Graphique des paiements reçus par période",
    defaultSize: "medium",
    icon: "chart",
    category: "finances",
  },
  {
    id: "payment_success_rate",
    label: "Taux de réussite paiements",
    description: "Pourcentage de paiements réussis vs échoués",
    defaultSize: "medium",
    icon: "chart",
    category: "finances",
  },
  {
    id: "recall_campaigns",
    label: "Campagnes de rappel",
    description: "Campagnes de rappel constructeur en cours",
    defaultSize: "small",
    icon: "warning",
    category: "ordres",
  },
  {
    id: "client_satisfaction",
    label: "Satisfaction client",
    description: "Note moyenne et avis négatifs récents",
    defaultSize: "small",
    icon: "star",
    category: "clients",
  },
  {
    id: "recent_messages",
    label: "Messages récents",
    description: "Dernières discussions avec clients",
    defaultSize: "small",
    icon: "message",
    category: "clients",
  },
  {
    id: "team_activity",
    label: "Activité de l'équipe",
    description: "Dernière connexion de chaque membre",
    defaultSize: "small",
    icon: "users",
    category: "equipe",
  },
];

// --- Role presets (default layouts) ---

const PRESET_LAYOUTS: Record<RolePreset, WidgetId[]> = {
  receptionniste: [
    "stat_cards",
    "rdv_du_jour",
    "recent_messages",
    "devis_en_attente",
    "paiements_en_attente",
    "recent_ordres",
    "client_satisfaction",
  ],
  atelier: [
    "stat_cards",
    "ordres_bloques",
    "rdv_du_jour",
    "recent_ordres",
    "recall_campaigns",
    "ordres_by_status",
  ],
  admin: [
    "stat_cards",
    "payments_chart",
    "ordres_by_status",
    "payment_success_rate",
    "client_satisfaction",
    "team_activity",
    "recall_campaigns",
    "recent_messages",
  ],
  comptabilite: [
    "stat_cards",
    "payments_chart",
    "payment_success_rate",
    "paiements_en_attente",
    "devis_en_attente",
    "ordres_by_status",
  ],
};

export function getPresetLayout(preset: RolePreset): WidgetConfig[] {
  const ids = PRESET_LAYOUTS[preset];
  return ids.map((id, i) => ({
    id,
    position: i,
    size: WIDGET_CATALOG.find((w) => w.id === id)?.defaultSize || "medium",
  }));
}

export function getDefaultLayout(): WidgetConfig[] {
  return getPresetLayout("admin");
}

export function getWidgetMeta(id: WidgetId): WidgetMeta | undefined {
  return WIDGET_CATALOG.find((w) => w.id === id);
}
